import React from 'react'

const Analytics = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="m3.182 17.396 4.75-4.799V21h-4.75v-3.604zm5.954-3.605V21h4.75v-7.209l-2.407 2.41-2.343-2.41zM15.068 21h4.75V7.799l-4.75 4.798V21zm2.364-18 1.351 1.365-7.283 7.38L7.932 8.16 2 14.154v1.706l5.932-5.993L11.5 13.45l8.149-8.232L21 6.583V3h-3.568z" fill="#0D1536" fillOpacity=".65"/>
  </svg>
)

export default Analytics
